import { render } from "./ChatCloseableTicketList.vue?vue&type=template&id=bd6a6ba0"
import script from "./ChatCloseableTicketList.vue?vue&type=script&lang=js"
export * from "./ChatCloseableTicketList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__